import { render, staticRenderFns } from "./PrimeDataTable.vue?vue&type=template&id=3baba80a&scoped=true&"
import script from "./PrimeDataTable.vue?vue&type=script&lang=js&"
export * from "./PrimeDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PrimeDataTable.vue?vue&type=style&index=0&id=3baba80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baba80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VRow,VTooltip})
